import React, { useContext } from "react";
import { CartContext } from "../../contex/CartProvider";
import CartItem from "../../molecules/CartItem";
import PinkButton from "../../molecules/PinkButton";

const Cart = () => {
  const { cart, updateItem } = useContext(CartContext);
  const [totalCost, setTotalCost] = React.useState(Number);
  React.useEffect(() => {
    console.log("🚀 ~ Cart ~ cart", cart);
    setTotalCost(0);
    cart?.forEach((item) =>
      setTotalCost((prevCost) => +prevCost + +item.totalPrice)
    );
  }, [cart]);
  return (
    <div className="mb-6">
      <div className="m-auto bg-light rounded-xl p-6">
        {/* Items Card Area */}
        <div className="max-h-80 md:max-h-96 overflow-y-auto px-2 mb-6">
          {cart?.map((item, index) => (
            <CartItem item={item} key={index} updateItem={updateItem} />
          ))}
        </div>

        <div className="text-center text-dark font-medium text-base mb-4">${totalCost}.00</div>

        {/* Button Area */}
        <div className="flex flex-col space-y-4 mx-8">
          <PinkButton text="proceed to checkout" />
          <PinkButton text="add to favorites" />
        </div>
      </div>
    </div>
  );
};

export default Cart;
